import { Option } from '@helvetia/components/forms/NativeSelect/NativeSelect.types'
import { Radio } from '@helvetia/components/forms/RadioButton'
import { Col, Row } from '@helvetia/components/layout'
import { FieldProps } from 'formik'
import * as React from 'react'

import { QuestionWrapper } from './common.styles'

interface Props {
  defaultSelected?: string
  onChange?: (event) => void
  questionText?: string
  radioList: Option[]
}

interface State {
  selectedValue: string
}

export class RadioGroup extends React.Component<Props & FieldProps, State> {
  state = {
    selectedValue: this.props.defaultSelected ? this.props.defaultSelected : '',
  }

  handleChange = event => {
    this.props.form.setFieldValue(
      this.props.field.name,
      event.currentTarget.value,
    )
    if (this.props.onChange) this.props.onChange(event)
    this.setState({ selectedValue: event.currentTarget.value })
  }

  static getDerivedStateFromProps(props, state) {
    return {
      selectedValue: props.defaultSelected ? props.defaultSelected : '',
    }
  }

  render() {
    const { questionText, radioList } = this.props
    return (
      <>
        {questionText && (
          <QuestionWrapper as="div" color="black" marginBottom="xxs">
            {questionText}
          </QuestionWrapper>
        )}

        {radioList.map((radio, index) => (
          <Radio
            key={index}
            label={radio.text}
            value={radio.value.toString()}
            checked={radio.value === this.state.selectedValue}
            name={this.props.field.name}
            onChange={this.handleChange}
          />
        ))}
      </>
    )
  }
}
